
    import './styles.scoped.css';
    export default {
  "dimmed": "awsui_dimmed_10ipo_a8a86_93",
  "root": "awsui_root_10ipo_a8a86_122",
  "list": "awsui_list_10ipo_a8a86_135",
  "list-item": "awsui_list-item_10ipo_a8a86_142",
  "key": "awsui_key_10ipo_a8a86_147"
};
  